module.exports = __webpack_public_path__ + "static/img/cgal17.0ca63f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal17.png
// module id = wRUp
// module chunks = 1